/**
 * Slack Migration API Schemas
 */

import { z } from "zod";

export const SlackMigrationBotSchema = z.object({
  id: z.string(),
  organizationId: z.string(),
  teamName: z.string().nullable(),
  botName: z.string().nullable(),
  appId: z.string().nullable(),
  manifestVersion: z.number().nullable(),
  appIdStatus: z.enum(["present", "missing", "no_token"]),
  manifestStatus: z.enum(["current", "stale", "unknown"])
});

export const SlackMigrationStatusResponseSchema = z.object({
  total: z.number(),
  withAppId: z.number(),
  withoutAppId: z.number(),
  manifestCurrent: z.number(),
  manifestStale: z.number(),
  bots: z.array(SlackMigrationBotSchema)
});

export const BackfillSlackBotBodySchema = z.object({
  connectionId: z.string().uuid()
});

export const BackfillSlackBotResponseSchema = z.object({
  success: z.boolean(),
  appId: z.string().optional(),
  error: z.string().optional()
});
